module.exports = __webpack_public_path__ + "images/instructor-anastasia-kuznetsova-mobile.webp";